import TablaYounet from '../Elementos/TablaYounet';


const Element =()=>{

    const headCellsColumn = [
        { id: 'Nombres', numeric: false, disablePadding: false, label: 'Nombres', show:true, fixed:false, width:200, num:0, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'NombresCompletos', numeric: false, disablePadding: false, label: 'Nombres Completos', show:true, fixed:false, width:350, num:1, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'CI', numeric: false, disablePadding: false, label: 'CI', show:true, fixed:false, width:150, num:2, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Celular', numeric: false, disablePadding: false, label: 'Celular', show:true, fixed:false, width:150, num:3, align:'left', fontSize:'16px', bolder:false, type:'text' },
        { id: 'Correo', numeric: false, disablePadding: false, label: 'Correo', show:true, fixed:false, width:250, num:4, align:'left', fontSize:'16px', bolder:false, type:'text' },
    ];

    const variablesObject = {
        api:'/api/Tecnicos',
        apiMultiples:'/api/Tecnicos/multiple',
        isButtonAdd:true,
        isMultiline:false,
        isUpperCase:false,
        label:'Tecnico',  
        nameLocalStorage:'headersTecnicosYounet',
        order:'asc',
        orderBy:'Nombres',
        rowsPerPage:15,
        sumWidth:1260,
        title:'TECNICOS',
        titleColor:'#3b5999',
        titleSizeXL:18,
        titleSizeXS:13,
        widthAction:160,
        Ruta:'Conf/Tecnicos',
        apiSecond:'/api/StockybyTecnico',
        isSecondApi:true,
        apiSecondOk:true,
        apiSecondOkTitle:'',
        apiSecondTitle:'Stock',
        apiSecondIcon:'RouterIcon',
        apiSecondType:'Stock',
        apiSecondHeaders:[ 'Marca', 'Modelo', 'Mac', 'Status' ],
        apiSecondIsFetch:true,
        apiSecondWidth:1150,
        rowDown:'', // Nombre de Array dentro de Data para poder crear una segunda tabla
        isRowDown:true // Activa el Boton Para Eventos
    };

    return (
        <TablaYounet
            headCellsColumn={headCellsColumn}
            variablesObject={variablesObject}
        />
    )
}

export default Element;